// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"_2jnDXF","button":"_2CN7-h"};